export const PROGRAM_COVER_SECTIONS = [
  { kind: 'benefits', title: "What you'll get", hint: 'Mentorship, workshops, investor access, workspace…' },
  { kind: 'eligibility', title: 'Who should apply', hint: 'Stage, sectors, geography, or founder requirements…' },
  { kind: 'format', title: 'Program at a glance', hint: 'Duration, location, online/in-person, cohort size…' },
  { kind: 'support', title: 'Funding & support', hint: 'Investment, grants, credits, fees, or equity terms…' },
  { kind: 'timeline', title: 'Key dates', hint: 'Selection, interviews, kickoff, and demo day…' },
  { kind: 'contact', title: 'Get in touch', hint: 'Program team contact details for applicant questions…' },
];
export const coverSectionTitle = section => section.title?.trim() || PROGRAM_COVER_SECTIONS.find(item => item.kind === section.kind)?.title || 'Program details';
